import "core-js/modules/es6.regexp.replace.js";
import { setBrand } from "./utils/colors.js";
import { noop } from "./utils/event.js";
import { onKeyDownComposition } from "./utils/key-composition.js";
import { isSSR, fromSSR, client, iosCorrection } from "./plugins/Platform.js";

function getMobilePlatform(is) {
  if (is.ios === true) return 'ios';
  if (is.android === true) return 'android';
}

function getBodyClasses(_ref, cfg) {
  var is = _ref.is,
      has = _ref.has,
      within = _ref.within;
  var cls = [is.desktop === true ? 'desktop' : 'mobile', "".concat(has.touch === false ? 'no-' : '', "touch")];

  if (is.mobile === true) {
    var mobile = getMobilePlatform(is);
    mobile !== void 0 && cls.push('platform-' + mobile);
  }

  if (is.nativeMobile === true) {
    var type = is.nativeMobileWrapper;
    cls.push(type);
    cls.push('native-mobile');

    if (is.ios === true && (cfg[type] === void 0 || cfg[type].iosStatusBarPadding !== false)) {
      cls.push('q-ios-padding');
    }
  } else if (is.electron === true) {
    cls.push('electron');
  } else if (is.bex === true) {
    cls.push('bex');
  }

  within.iframe === true && cls.push('within-iframe');
  return cls;
} // SSR takeover corrections


function clientUpdate() {
  var classes = document.body.className;
  var newCls = classes;

  if (iosCorrection !== void 0) {
    newCls = newCls.replace('desktop', 'platform-ios mobile');
  }

  if (client.has.touch === true) {
    newCls = newCls.replace('no-touch', 'touch');
  }

  if (client.within.iframe === true) {
    newCls += ' within-iframe';
  }

  if (classes !== newCls) {
    document.body.className = newCls;
  }
}

function setColors(brand) {
  for (var color in brand) {
    setBrand(color, brand[color]);
  }
}

export default {
  install: function install(queues, cfg) {
    if (isSSR === true) {
      queues.server.push(function (q, ctx) {
        var cls = getBodyClasses(q.platform, cfg),
            fn = ctx.ssr.setBodyClasses;

        if (cfg.screen !== void 0 && cfg.screen.bodyClass === true) {
          cls.push('screen--xs');
        }

        if (typeof fn === 'function') {
          fn(cls);
        } else {
          ctx.ssr.Q_BODY_CLASSES = cls.join(' ');
        }
      });
      return;
    }

    if (fromSSR === true) {
      clientUpdate();
    } else {
      var cls = getBodyClasses(client, cfg);

      if (client.is.ie === true && client.is.versionNumber === 11) {
        cls.forEach(function (c) {
          return document.body.classList.add(c);
        });
      } else {
        document.body.classList.add.apply(document.body.classList, cls);
      }
    }

    cfg.brand !== void 0 && setColors(cfg.brand);

    if (client.is.ios === true) {
      // needed for iOS button active state
      document.body.addEventListener('touchstart', noop);
    }

    window.addEventListener('keydown', onKeyDownComposition, true);
  }
};